/* import __COLOCATED_TEMPLATE__ from './label.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class FinGuaranteeLabel extends Component {
  @service intercomEventService: any;
  @tracked isOpen = false;

  @action
  onModalOpen(object: string) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object,
      context: 'show_fin_guarantee_modal',
    });
    this.isOpen = true;
  }

  @action
  onModalClose(object: string) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object,
      context: 'close_fin_guarantee_modal',
    });
    this.isOpen = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinGuarantee::Label': typeof FinGuaranteeLabel;
    'fin-guarantee/label': typeof FinGuaranteeLabel;
  }
}
